import { render } from "./selectUserModal.vue?vue&type=template&id=43f9e1be&ts=true"
import script from "./selectUserModal.vue?vue&type=script&lang=ts"
export * from "./selectUserModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__